module.exports = "/_next/static/images/wechat-25bce3fc.png";